import { render, staticRenderFns } from "./EnacCustomBehaviouralIndicatorEditStruct.vue?vue&type=template&id=0ac6becc"
import script from "./EnacCustomBehaviouralIndicatorEditStruct.vue?vue&type=script&lang=js"
export * from "./EnacCustomBehaviouralIndicatorEditStruct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports